import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { fetchSubsidiaryDashboards } from '../services/dashboard-configuration.service';
import type { ConfigurationPlatform } from '../types/configuration.types';

import { usePlatformId } from './usePlatformId';

/**
 * Loads the active subsidiary's resolved dashboard list (override or
 * platform default per row). Mirrors `useDashboardConfiguration` —
 * `X-Subsidiary-ID` is attached automatically by `subsidiaryInterceptor`.
 *
 * `enabled` (default `true`) lets `useConfigurationDashboardConfiguration`
 * mount this alongside `useDashboardConfiguration` and disable whichever
 * mode isn't active.
 */
export function useSubsidiaryDashboardConfiguration(
  platform: ConfigurationPlatform,
  enabled = true,
) {
  const platformId = usePlatformId(platform);

  return useQuery({
    queryKey: queryKeys.configuration.subsidiaryDashboards(platformId ?? ''),
    queryFn: () => fetchSubsidiaryDashboards(platformId ?? ''),
    enabled: !!platformId && enabled,
  });
}
